import ChimeraTrig from '../components/chimera/ChimeraTrig';

function ChimeraTrigPage() {
  return (
    <div className="min-h-screen bg-black">
      <ChimeraTrig />
    </div>
  );
}

export default ChimeraTrigPage;
